import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import i18n from 'i18n-js';
import { buildUrl } from 'utils';
import Can from 'components/Can';
import Layout from 'components/Layout';
import Comments from 'components/Comments';
import { useHistory, useParams } from 'react-router-dom';
import DocumentsWidget from 'components/Documents/Widget';
import { userGroupsActions } from 'state/modules/userGroups';
import { PaymentMethods } from 'components/PaymentMethods';
import { Details, DealerLogs } from 'components/Dealer';

const DealerDetails = () => {
  const history = useHistory();
  const { id } = useParams();
  const dispatch = useDispatch();
  const { userGroup, fetchedAddItem } = useSelector((state) => state.userGroups);
  const [currentParentsParams] = useState({
    page: 1,
    limit: 3,
  });

  const payment_methods_allowed =
    useSelector((state) => state?.config?.settings?.core?.payment?.payment_methods_allowed) || [];

  const fetchParents = (params = {}) => {
    dispatch(userGroupsActions.fetchParents(id, params, 'parents', 'parentsModal'));
  };

  useEffect(() => {
    if (id) {
      fetchParents(currentParentsParams);
      dispatch(userGroupsActions.fetchUserGroupById(id, 'deatils', 'business'));
    }
    dispatch(userGroupsActions.resetUpdateUserGroup());
  }, []); // eslint-disable-line

  useEffect(() => {
    if (fetchedAddItem) {
      fetchParents(currentParentsParams);
    }
  }, [fetchedAddItem]); // eslint-disable-line

  /**
   * Go to user groups list page
   */
  const goToUserGroupsList = () => {
    history.push(buildUrl('/dealers'));
  };

  /**
   * Go to create user group page
   */
  const goToCreateUserGroup = () => {
    dispatch(userGroupsActions.resetOnboarding());
    history.push(buildUrl('/dealers/create'));
  };

  return (
    <Layout title={i18n.t('user_groups.dealer')}>
      <Container sx={{ minWidth: '100%', margin: 0 }}>
        <Grid container spacing={2}>
          <Grid size={12}>
            <Grid container direction="row" justifyContent="space-between" spacing={2}>
              <Grid>
                <Typography variant="h6" gutterBottom>
                  <Box fontWeight="fontWeightBold" fontSize={24} mb={1}>
                    {i18n.t('user_groups.dealer')} #{id}
                  </Box>
                </Typography>
              </Grid>
              <Grid>
                <Can I="read" a="user_group">
                  <Button
                    color="primary"
                    variant="outlined"
                    onClick={goToUserGroupsList}
                    style={{ textTransform: 'inherit' }}
                  >
                    {i18n.t('user_group.see_all_dealers')}
                  </Button>
                </Can>
                <Can I="create" a="user_group">
                  <Button
                    color="primary"
                    variant="contained"
                    onClick={goToCreateUserGroup}
                    style={{ textTransform: 'inherit', marginLeft: 10 }}
                  >
                    {i18n.t('user_group.add_dealer')}
                  </Button>
                </Can>
              </Grid>
            </Grid>
          </Grid>
          <Grid size={12}>
            <Grid container spacing={2}>
              <Grid size={{ xs: 12, sm: 12, md: 4 }}>
                <Grid container spacing={2}>
                  <Grid size={12}>
                    <Details id={parseInt(id)} />
                  </Grid>
                  {Boolean(payment_methods_allowed.length) && (
                    <Can I="read" on="payment_method">
                      <Grid size={12}>
                        <PaymentMethods
                          modelId={id}
                          accountId={userGroup?.account_id}
                          type="dealers"
                        />
                      </Grid>
                    </Can>
                  )}
                </Grid>
              </Grid>
              <Grid size={{ xs: 12, sm: 12, md: 4 }}>
                <Grid container spacing={2}>
                  <Can I="read" a="document">
                    <Grid size={{ xs: 12, sm: 12, md: 12 }}>
                      <DocumentsWidget type="user_group" id={parseInt(id)} />
                    </Grid>
                  </Can>
                  <Grid size={12}>
                    <Comments type="user_group" id={parseInt(id)} />
                  </Grid>
                </Grid>
              </Grid>

              <Grid size={{ xs: 12, sm: 12, md: 4 }}>
                <Grid container spacing={2}>
                  <Can I="read" on="event_log">
                    <Grid size={12}>
                      <DealerLogs id={id} type={'BUSINESS'} />
                    </Grid>
                  </Can>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </Layout>
  );
};

export default DealerDetails;
